export const appVerboseName = "Certipers";
